export default "__VITE_ASSET__DDi9oA8l__"